module.exports = __webpack_public_path__ + "img/abou_us_1.43ad00ed.webp";